// auth.js

import { put, call, takeEvery } from "redux-saga/effects";

import { apiCredentials } from "../../utils/auth.js";

export const INITIAL_STATE = {
  isCheckingAuthentication: false,
  isAuthenticated: false,
};

// action types
const UNAUTHENTICATED = "trace-web/auth/UNAUTHENTICATED";
const CHECK_AUTHENTICATION = "trace-web/auth/CHECK_AUTHENTICATION";
const AUTHENTICATED = "trace-web/auth/AUTHENTICATED";

// reducer
export default function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case UNAUTHENTICATED:
      return {
        ...state,
        ...INITIAL_STATE,
      };
    case CHECK_AUTHENTICATION:
      return {
        ...state,
        isCheckingAuthentication: true,
        isAuthenticated: false,
      };
    case AUTHENTICATED:
      return {
        ...state,
        isCheckingAuthentication: false,
        isAuthenticated: true,
      };
    default:
      return state;
  }
}

// action creators
export function unauthenticated() {
  return { type: UNAUTHENTICATED };
}

export function checkAuthentication() {
  return { type: CHECK_AUTHENTICATION };
}

export function authenticated() {
  return {
    type: AUTHENTICATED,
  };
}

// sagas
export function* authWatcher() {
  yield takeEvery(CHECK_AUTHENTICATION, authWorker, apiCredentials());
}

export function* authWorker(credentials) {
  const { user, token } = credentials;

  if (user && token) {
    yield put(authenticated());
  } else {
    yield put(unauthenticated());
    yield call(loginRedirect);
  }
}

// state of the art redirecting in the frontend =(
const loginRedirect = () => {
  // this setTimeout **should** be removed in a follow on issue where we
  // address the limitations of our redirect strategy.
  window.setTimeout(() => {
    let parser = document.createElement("a");
    parser.href = window.location;
    window.location.href = "//" + parser.hostname + "/sign_in";
  }, 2000);
};
